(function () {
    'use strict';

    angular
        .module('core.directives')
        .directive('header', Header)

    /** @ngInject */
    function Header($rootScope, $window, AuthenticationService, UtilHelper, AppCycleHelper, PATHS, DATA_EVENTS) {
        function HeaderController($scope) {
            const vm = this;

            vm.onChangeCompany = () => {
                const currentSelectedCompany = AuthenticationService.getUser().Company;

                if (vm.selectedCompany.Id && vm.selectedCompany.Id != currentSelectedCompany.Id) {
                    AuthenticationService
                        .setCompany(vm.selectedCompany.Id)
                        .then(response => {
                            $rootScope.$broadcast(DATA_EVENTS.SELECTED_COMPANY_CHANGE);

                            if (response.error)
                                AppCycleHelper.handleStateChangeError(response);
                        }, error => {
                            $rootScope.$broadcast(DATA_EVENTS.SELECTED_COMPANY_CHANGE);
                            AppCycleHelper.handleStateChangeError(error);
                        })
                }
            }

            vm.toggleMenu = () => {
                $rootScope.menuOpen = !$rootScope.menuOpen;
            }

            vm.toggleSelectUnit = () => {
                $rootScope.showSelectCompany = !$rootScope.showSelectCompany;
            }

            let removeWatchUnit = $rootScope.$on(DATA_EVENTS.SELECTED_COMPANY_CHANGE, () => {
                vm.modules = [];

                init();
            })

            angular.element($window).on('resize', () => {
                $rootScope.isMobile = UtilHelper.isScreenSmaller(991);
            })

            $scope.$on('$destroy', () => {
                removeWatchUnit();
                angular.element($window).unbind('resize');
            })

            init();

            function init() {
                const authSelectedCompany = AuthenticationService.getUser().Company;

                vm.toolName = $rootScope.toolName;
                vm.isMobile = $rootScope.isMobile;
                vm.logout = AuthenticationService.logout;
                vm.companies = AuthenticationService.getCompanies();

                let foundCompany = vm.companies.find(company => (company.Id == authSelectedCompany.Id));

                if (foundCompany)
                    vm.selectedCompany = foundCompany;
            }
        }

        return {
            bindToController: true,
            controller: HeaderController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/header/header.html`,
            scope: {}
        }
    }
}());